import { Col, Row } from 'antd';
import { Fragment, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import CustomCard from '../../../components/Antd/Card';
import CustomImage from '../../../v2-components/Antd/Image';
import CustomLink from '../../../v2-components/Antd/Link';
import { CustomNotification } from '../../../v2-components/Notification';
import { capitalizeFirstLetter } from '../handle/capitalize-first-letter.handle';
import { Service } from '../service';
import usePharmacyStore from '../templates/store/pharmacy-store';
import { cardState } from './handle/card-state.handle';

import './style.scss';
import Loading from '../../../v2-components/Loading';
import { nameAdapter } from './handle/name-adapter.handle';

export default function PharmacySliderLocationsPage() {
	const { template } = useParams();
	const [loading, setLoading] = useState(true);
	const [pharmacyLocations, selectedPharmacy, locations, setLocations, platform, ecosystem] = usePharmacyStore((state) => [
		state.pharmacyLocations,
		state.selectedPharmacy,
		state.locations,
		state.setLocations,
		state.platform,
		state.ecosystem,
	]);

	useEffect(() => {
		setLoading(true);
		if (pharmacyLocations.length > 0) {
			new Service()
				.getModulesByTemplate(template, ecosystem, selectedPharmacy)
				.then((response) => {
					const data = response;
					setLocations(data);
				})
				.catch((error) => {
					CustomNotification({ type: 'error', description: 'Ha ocurrido un error al obtener los modulos por template:', message: error });
				});
		}
		setLoading(false);
	}, [template, pharmacyLocations, selectedPharmacy, setLocations, ecosystem]);

	return (
		<div className="pharmacy-sliders-locations">
			<h1>
				{capitalizeFirstLetter(nameAdapter(selectedPharmacy,platform))} / {template} {selectedPharmacy === 'fanich' ? 'Anich' : selectedPharmacy.toUpperCase()}
			</h1>
			<Link to={'/v2/pharmacy-sliders?pharmacy=' + selectedPharmacy}>
				Volver a {capitalizeFirstLetter(nameAdapter(selectedPharmacy,platform))} / {selectedPharmacy === 'fanich' ? 'Anich' : selectedPharmacy.toUpperCase()}
			</Link>
			<h2>Seleccionar módulo a editar</h2>
			<Row gutter={[16, 16]} className="location">
				{loading ? (
					<Loading />
				) : (
					locations?.map((iterator, key) => {
						return (
							<Fragment key={key}>
								<Col md={8} xs={24}>
									<CustomLink
										className="card-link"
										to={`/v2/pharmacy-sliders/templates/${template}/locations/${iterator.location}`}
									>
										<CustomCard
											className="pharmacy-sliders-cards"
											title={
												<div className="card-header-container">
													<h3>{iterator.editable_name}</h3>
													<div className="inner-container">
														<p>{cardState(iterator.files)}</p>
													</div>
												</div>
											}
										>
											<CustomImage src={iterator.img_cover} alt="img" preview={false} />
										</CustomCard>
									</CustomLink>
								</Col>
							</Fragment>
						);
					})
				)}
			</Row>
		</div>
	);
}
